import React from 'react';
import { Card, Row, Col } from 'antd';
import { Link } from 'react-router-dom';

import { getFullName } from 'utils/personUtils';
import { getLocation } from 'utils/locationUtils';
import BaseLabel from 'components/wrappers/BaseLabel';
import { getRecruiterStatusName } from 'utils/recruiterUtils';
import { getAccountTypeLabel, getProfileTypeLabel } from 'utils/accountUtils';
import { BOAccountViewModel } from 'api/adminApiClient';

import styles from './RecruiterCard.module.less';

type Props = {
  recruiter: BOAccountViewModel;
};

export default function RecruiterCard(props: Props) {
  const { recruiter } = props;
  const {
    userId,
    memberKey,
    firstName,
    lastName,
    companyName,
    email,
    contactPhoneNumber,
    city,
    state,
    status,
    boUserType,
    profileType,
    countryName,
    internationalCityName,
    internationalStateName,
  } = recruiter;

  const getRecruiterLocation = () => {
    return getLocation(
      countryName,
      city || internationalCityName,
      state || internationalStateName,
    );
  };

  const recruiterLocation = getRecruiterLocation();
  const recruiterFullName = getFullName(firstName, lastName);
  const recruiterStatus = getRecruiterStatusName(status);

  return (
    <Card
      className="card-item size-sm stretch-card"
      data-id={`member-${userId}`}
    >
      <div className="card-inner h-centered">
        <div className="inner-text-box">
          <div data-id="member-name">
            <Link className="card-title" to={`/member/${memberKey}`}>
              {recruiterFullName}
            </Link>
          </div>

          <div className="card-link">{companyName}</div>
        </div>
      </div>

      <Row gutter={[20, 10]} className="titled-sheet">
        {boUserType && (
          <Col xs={24} md={12} data-id="account-type">
            <div className="title">Account type: </div>
            <div>{getAccountTypeLabel(boUserType)}</div>
          </Col>
        )}

        {profileType && (
          <Col xs={24} md={12} data-id="profile-type">
            <div className="title">Profile type: </div>
            <div>{getProfileTypeLabel(profileType)}</div>
          </Col>
        )}

        {memberKey && (
          <Col xs={24} md={12} data-id="member-id">
            <div className="title">Member ID: </div>
            <div>{memberKey}</div>
          </Col>
        )}

        {recruiterLocation && (
          <Col xs={24} md={12} data-id="billing-location">
            <div className="title">Billing location: </div>
            <div>{recruiterLocation}</div>
          </Col>
        )}

        {contactPhoneNumber && (
          <Col xs={24} md={12} data-id="contact-number">
            <div className="title">Contact number: </div>
            <div>{contactPhoneNumber}</div>
          </Col>
        )}

        {email && (
          <Col xs={24} md={12} data-id="email">
            <div className="title">Email: </div>
            <div>{email}</div>
          </Col>
        )}

        <Col xs={24} className={styles.col} data-id="status-label">
          <BaseLabel status={recruiterStatus} />
        </Col>
      </Row>
    </Card>
  );
}
